import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import 'moment/locale/en-au';
import { useIntl } from 'react-intl';
import { SearchBarContext, SubmitOnEnterOverSelectCallback } from '../../../../components/SearchBar';
import SearchBarRow from '../../../../components/SearchBar/SearchBarRow';
import { Controller } from "react-hook-form";

const PrimarySearchItems = () => {
  const intl = useIntl();
  const { register } = useContext(SearchBarContext);

  return (
    <SearchBarRow>
      <div className="form-group">
        <label>{intl.formatMessage({ id: 'students.search.training-key-field' })}</label>
        <input className="form-control" {...register('training_key')}></input>
      </div>

      <div className="form-group">
        <label>{intl.formatMessage({ id: 'students.search.first-name-field' })}</label>
        <input className="form-control" {...register('first_name')}></input>
      </div>

      <div className="form-group">
        <label>{intl.formatMessage({ id: 'students.search.last-name-field' })}</label>
        <input className="form-control" {...register('last_name')}></input>
      </div>

      <div className="form-group">
        <label>{intl.formatMessage({ id: 'students.search.email-field' })}</label>
        <input className="form-control" {...register('email')}></input>
      </div>
    </SearchBarRow>
  );
};

const SecondarySearchItems = (props) => {
  const intl = useIntl();
  const { register, control, setValue } = useContext(SearchBarContext);
  const [orgId, setOrgId] = React.useState(props.organisationId || '');

  const filteredDepartments = useMemo(() => {
    if (orgId) {
      return (props.departments ?? []).filter(dept => dept.organisation_id === parseInt(orgId));
    }
    return [];
  }, [props.departments, orgId]);


  return (
    <SearchBarRow>
      <div className="form-group">
        <label>{intl.formatMessage({ id: 'students.search.mobile-field' })}</label>
        <input className="form-control" {...register('mobile')}></input>
      </div>

      <div className="form-group">
        <label>{intl.formatMessage({ id: 'students.search.organisation-field' })}</label>
        <Controller
          control={control}
          name="organisation"
          render={({ field }) => (
            <select
              autoFocus
              name="organisation"
              className="form-control"
              onKeyUp={SubmitOnEnterOverSelectCallback}
              onChange={(e) => {
                setOrgId(props.organisations.find((org) => org.name === e.target.value)?.id || '');
                field.onChange(e.target.value)
                setValue('department_id', null);
              }}
              disabled={props.organisationId}
            >
              {!props.organisationId && (
                <option key="0" value="">
                  {intl.formatMessage({ id: 'shared.dropdown.please-select' })}
                </option>
              )}
              {props.organisations.map((org) => (
                <option key={org.id} value={org.name}>
                  {org.name}
                </option>
              ))}
            </select>
          )}
        />
      </div>

      <div className="form-group">
        <label>{intl.formatMessage({ id: 'students.search.department-field' })}</label>
        <select
          autoFocus
          className="form-control" {...register('department_id')}
          onKeyUp={SubmitOnEnterOverSelectCallback}
          disabled={filteredDepartments.length === 0}
        >
          <option key="0" value="">
            {intl.formatMessage({ id: 'shared.dropdown.please-select' })}
          </option>
          {filteredDepartments.map((department) => (
            <option key={department.id} value={department.id}>
              {department.name}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>{intl.formatMessage({ id: 'students.search.status-field' })}</label>
        <select className="form-control" {...register('showArchived')} onKeyUp={SubmitOnEnterOverSelectCallback}>
          <option value="">{intl.formatMessage({ id: 'shared.no' })}</option>
          <option value="yes">{intl.formatMessage({ id: 'shared.yes' })}</option>
        </select>
      </div>
    </SearchBarRow>
  );
};

SecondarySearchItems.propTypes = {
  organisationId: PropTypes.number,
  organisations: PropTypes.array.isRequired,
  departments: PropTypes.array.isRequired,
};

export { PrimarySearchItems, SecondarySearchItems };
